import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_sub_ledger_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  sub_ledger_hdr_guid: fromDatatype.GuidDataFieldInterface;
  jrnl_hdr_guid: fromDatatype.GuidDataFieldInterface;
  jrnl_line_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
}

export class bl_fi_sub_ledger_line_RowClass
  implements bl_fi_sub_ledger_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  sub_ledger_hdr_guid: fromDatatype.GuidDataFieldInterface;
  jrnl_hdr_guid: fromDatatype.GuidDataFieldInterface;
  jrnl_line_guid: fromDatatype.GuidDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
}
